import { Component, OnInit, Output, EventEmitter, NgZone, Input } from '@angular/core';
import { VehiclesService } from '@app/shared/services/vehicles.service';
declare var UIkit: any;

@Component({
  selector: 'app-find-vehicle',
  templateUrl: './find-vehicle.component.html',
  styleUrls: ['./find-vehicle.component.scss']
})
export class FindVehicleComponent {

  public vehicle : any = {};
  public loading : boolean = false;
  public vehicleSet : boolean = false;
  public vehicleSearch : string = '';
  public vehicleSelected : number = 0;
  public options : any = [];
  public vehicleDisplay : boolean = false;
  public noResult : boolean = false;
  public _timeout : any = null;

  @Input() actualVehicles = [];
  @Output() changed = new EventEmitter();

  constructor(
    private vehicleService: VehiclesService,
    private lc: NgZone
  ) {}

  resetVariables() {
    this.vehicle = {};
    this.actualVehicles = [];
    this._timeout = null;
    this.noResult = false;
    this.loading = false;
    this.vehicleSet = false;
    this.vehicleSearch = '';
    this.vehicleSelected = 0;
    this.options = [];
    this.vehicleDisplay = false;
  }

  sendUser() {
    this.changed.emit(this.vehicle);
    this.resetVariables();
    UIkit.modal('#find-vehicle').hide();
  };

  updateVehicleOptionList(event) {
    if (this._timeout) {
      window.clearTimeout(this._timeout);
    }
    this._timeout = window.setTimeout(() => {
      this._timeout = null;
      this.lc.run(() => {
        this.vehicleSearch = event;
        this.loading = true;
        this.noResult = false;
        this.vehicleService.updateVehicles(1, this.vehicleSearch).then((res) => {
          if (res.length > 0) {
            res.forEach((vehicle) => {
              if (this.actualVehicles.find(v => v.id === vehicle.id) === undefined) {
                this.options.push(vehicle);
              }
            });
            this.noResult = (this.options.length > 0) ? false : true;
          } else {
            this.noResult = true;
          }
          this.loading = false;
        });
      });
    }, 1000);
  }

  setVehicleSearch(option) {
    this.vehicle = option;
    this.vehicleSet = true;
    this.vehicleSearch = option.name;
  }

  toggleSuggestions(shouldDisplay) {
    setTimeout(() => {
      this.vehicleDisplay = shouldDisplay;
    }, 250);
  }

}
